export interface QualityRangeModel {
  /**
   * i range devono essere definit in MB
   */
  readonly range: [number, number];
  /**
   * il valore deve essere tra 0 e 1 (https://github.com/fengyuanchen/compressorjs#quality)
   */
  readonly value: number;
}
